export enum AlertType {
  Daily = 'Daily',
  Instant = 'Every 15 Minutes',
  None = 'None',
}

export interface Preference {
  mode: AlertType;
}

export interface DocketAlertsDto {
  mode: AlertType;
  caseId: number;
  companyId: number;
}

export interface UpdateDocketAlertPreferencesArgs {
  preferences: Preference;
  caseId: number;
  companyId: number;
}

export interface AlertOption<TValue extends string> {
  value: TValue;
  label: string;
}

export const docketAlertOptions: AlertOption<AlertType>[] = [
  {
    label: 'Daily',
    value: AlertType.Daily,
  },
  {
    label: 'Every 15 Minutes',
    value: AlertType.Instant,
  },
  {
    label: 'None',
    value: AlertType.None,
  },
];
